export default {
  recommends: 'Reverb Recommends',
  topPick: 'Top Pick',
  reverbNews: 'Reverb News',
  treatYourself: 'Treat Yourself',
  seeSimilar: 'See Similar {{category}}',
  seeMore: 'See More',
  addToCart: 'Add to Cart',
  listingSellerLockedModeAlert: {
    lockedModeTitle: 'Locked Mode',
    lockedModeDescription: 'We need a few more details to verify your business. Reverb Support will be in contact with you via email to unlock your account. {{children}}',
    lockedModeHelpLinkText: 'Visit our help center for more info.',
  },
  listingSellerPaypalOnboardingAlert: {
    title: "Action required: We're making updates to our PayPal platform integration",
    description: 'This improves how we process payments for sellers who use their own PayPal account to process payments. To continue to sell without service disruption, {{children}}',
    linkText: 'please reconnect your PayPal account on the Shop Settings dashboard.',
  },
  listingSellerPaypalLockedModeAlert: {
    title: 'Important: Your shop has been locked',
    description: 'In a matter of minutes, unlock your shop by simply {{children}}',
    linkText: 'reconnecting your PayPal account on the Shop Settings page.',
  },
};
